require('inputmask');

$(document).ready(function () {
    //Селект
    $(document).click(function (e) {
        const dropdown = $('.js_form_select');
        if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
            $('.js_form_select_input').removeClass('active')
            $('.js_form_select_list').slideUp(300)
        }
    })

    $('.js_form_select_input').click(function (e) {
        e.preventDefault()
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $(this).closest('.js_form_select').find('.js_form_select_list').slideUp(300)
        } else {
            $(this).addClass('active')
            $(this).closest('.js_form_select').find('.js_form_select_list').slideDown(300)
        }

        $(this).closest('.js_form_input_wrapper').find('.js_form_error').removeClass('active');
    })

    $('.js_form_select_item').click(function (e) {
        e.preventDefault()
        if (!$(this).hasClass('active')) {
            let value = $(this).text().trim();
            let valueInput = $(this).data('value');
            $('.js_form_select_item').not($(this)).removeClass('active');
            $(this).addClass('active');
            $(this).closest('.js_form_select').find('.js_form_select_placeholder').text(value).addClass('choosed');
            $(this).closest('.js_form_input_wrapper').find('input[type="hidden"]').val(valueInput);
        }
        $('.js_form_select_input').removeClass('active')
        $('.js_form_select_list').slideUp(300);
    })

    //Чекбокс
    $('.js_form_checkbox_label').click(function () {
        if ($(this).closest('.js_form_input_wrapper').find('.js_form_checkbox').prop('checked')) {
            $(this).removeClass('active')
        } else {
            $(this).addClass('active')
            $(this).removeClass('error');
        }
    })

    //Обязательные поля
    $('.js_form_input').on('blur', function () {
        if ($(this).closest('.js_form_input_wrapper.required')) {
            let value = Boolean($(this).val().trim())
            if (!value) {
                $(this).siblings('.js_form_error').addClass('active')
            } else {
                $(this).siblings('.js_form_error').removeClass('active')
            }
        }
    });

    phoneMask();
});

function phoneMask() {
    var imUA = new Inputmask("+38(099) 999 99 99");
    imUA.mask($(".js__mask_phone"));
}